import React from "react";
import "./App.css";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Hero from "./components/Hero";
import AboutUs from "./components/AboutUs";
import Gallery from "./components/Gallery";
import Catalog from "./components/Catalog";
import QuoteForm from "./components/QuoteForm";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { Analytics } from '@vercel/analytics/react';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <AboutUs />
      <Gallery />
      <Catalog />
      <QuoteForm />
      <Contact />
      <Footer />
      <Toaster />
      <Analytics />
    </div>
  );
}

export default App;
